<template>
    <div>
        <h2 class="title is-4">
            Estate Transactions
        </h2>

        <Notification v-if="(transactions && ! hasTransactions)">
            No transactions found.
        </Notification>

        <Notification v-else-if="minimumDate">
            Transactions will only be displayed from {{ $dayjs(minimumDate).format('MMMM YYYY') }} onwards.
        </Notification>

        <div
            v-if="! (transactions && ! hasTransactions)"
            class="table-container"
        >
            <table class="table is-fullwidth is-bordered is-striped">
                <thead
                    v-if="(! transactions || hasTransactions)"
                    class="is-hidden-mobile"
                >
                    <tr>
                        <th>
                            <span class="is-hidden-touch">Transaction</span> Date
                        </th>
                        <th class="is-hidden-touch is-hidden-desktop-only">
                            Statement
                        </th>
                        <th class="is-hidden-touch">
                            Description
                        </th>
                        <th class="is-hidden-touch">
                            Address
                        </th>
                        <th class="has-text-right is-hidden-touch">
                            Received
                        </th>
                        <th class="has-text-right is-hidden-touch">
                            Due
                        </th>
                        <th class="has-text-right is-hidden-touch">
                            Running Balance
                        </th>
                        <th class="is-hidden-desktop">
                            Amount
                        </th>
                    </tr>
                </thead>
                <tbody v-if="hasTransactions">
                    <EstateTransactionRow
                        v-for="row in transactions"
                        :key="row.TransactionPK"
                        :row="row"
                    />
                </tbody>
                <SkeletonRow
                    v-if="! transactions && ! hasTransactions"
                    :row-count="5"
                    :desktop-count="7"
                    :tablet-count="7"
                    :mobile-count="2"
                />
            </table>

            <b-tooltip
                v-if="hasTransactions"
                label="Download latest 1000 transactions as a CSV file"
                position="is-right"
            >
                <b-button
                    type="is-info"
                    tag="a"
                    :href="`/contacts/leaseholder/properties/${property.PropertyPK}/estate-transactions/download`"
                >
                    Download report
                </b-button>
            </b-tooltip>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Notification from '../components/Notification.vue';
import EstateTransactionRow from '../components/EstateTransactionRow.vue';
import SkeletonRow from '../components/SkeletonRow';

export default {
    components: {
        SkeletonRow,
        Notification,
        EstateTransactionRow,
    },

    computed: {
        ...mapState('leaseholdProperty', [
            'property',
        ]),
        ...mapState('leaseholdEstateTransactions', [
            'transactions',
        ]),
        ...mapGetters('leaseholdEstateTransactions', [
            'hasTransactions',
        ]),
        minimumDate() {
            return this.$meta.features.leaseholders.estate_transactions_from;
        },
    },

    mounted() {
        this.getTransactions();
    },

    methods: {
        getTransactions() {
            this.$store.dispatch('leaseholdEstateTransactions/getTransactions', {
                propertyPK: this.property.PropertyPK,
            });
        },
    },
};
</script>
